<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-form-item v-bind="errorsBind('non_field_errors')" />

    <a-form-item
      v-if="lecturers.length"
      v-bind="errorsBind('lecturer')"
      label="Lektor"
      required
    >
      <a-select
        v-model="form.lecturer"
        :options="lecturers"
        showSearch
        optionFilterProp="children"
      />
    </a-form-item>
    <a-form-item
      class="no-margin-and-padding"
      v-else
      v-bind="errorsBind('lecturer')"
    />

    <a-form-item v-bind="errorsBind('timespan')">
      <a-row :gutter="24">
        <a-col :sm="10">
          <a-form-item label="Data" class="no-margin-and-padding">
            <a-date-picker
              class="fluid"
              :allowClear="false"
              :disabledDate="todayOrAfter"
              v-model="masterDate"
              placeholder="Data"
            />
          </a-form-item>
        </a-col>
        <a-col :sm="7">
          <a-form-item label="Od" class="no-margin-and-padding">
            <a-time-picker
              class="fluid"
              :allow-clear="false"
              format="HH:mm"
              :minute-step="15"
              :disabled-hours="disabledHours"
              :hide-disabled-options="true"
              v-model="form.timespan.lower"
              placeholder="Data"
            />
          </a-form-item>
        </a-col>
        <a-col :sm="7">
          <a-form-item label="Do" class="no-margin-and-padding">
            <a-time-picker
              class="fluid"
              :allow-clear="false"
              format="HH:mm"
              :minute-step="15"
              :disabled-hours="disabledHours"
              :hide-disabled-options="true"
              v-model="form.timespan.upper"
              placeholder="Data"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form-item>

    <a-form-item label="Cykliczne" v-bind="errorsBind('interval')">
      <a-select
        v-model="form.interval"
        :options="intervalOptions"
        placeholder="Wybierz jeśli chcesz dodać dostępność cykliczną"
        allowClear
      />
    </a-form-item>
    <a-form-item
      v-if="form.interval"
      label="Do kiedy?"
      v-bind="errorsBind('interval_end')"
      required
    >
      <date-picker
        class="fluid"
        :disabledDate="disabledIntervalEnds"
        v-model="form.interval_end"
        placeholder="Ostatni dzień"
      />
    </a-form-item>
  </a-form>
</template>

<script>
import FieldHelper from '@/components/common/forms/FieldsHelper'
import moment from 'moment'

export default {
  data() {
    return {
      intervalOptions: [
        { label: 'Codziennie', value: 1 },
        { label: 'Co tydzień', value: 7 },
        { label: 'Co dwa tygodnie', value: 14 }
      ]
    }
  },
  extends: FieldHelper,
  props: {
    selectedDate: {
      type: [Date, Object],
      required: false
    },
    lecturers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    disabledHours() {
      return [0, 1, 2, 3, 4, 5, 22, 23, 24]
    },
    disabledIntervalEnds(current) {
      return current.isBefore(this.masterDate, 'day')
    },
    todayOrAfter(current) {
      const now = moment()
      return now.isAfter(current, 'day')
    },
    getMergedDateWithTimespan(newDate, timespan) {
      return {
        lower: this.mergeDateWithDatetime(newDate, timespan.lower),
        upper: this.mergeDateWithDatetime(newDate, timespan.upper)
      }
    },
    mergeDateWithDatetime(newDate, datetime) {
      const date = datetime
        ? datetime.clone()
        : this.stripMinuteAndSeconds(moment())
      return date.set({
        day: newDate.get('day'),
        month: newDate.get('month'),
        year: newDate.get('year')
      })
    }
  },
  computed: {
    masterDate: {
      set(value) {
        const newForm = {
          ...this.form,
          timespan: this.getMergedDateWithTimespan(value, this.form.timespan)
        }
        this.$emit('input', newForm)
        this.$emit('update:selectedDate', value)
      },
      get() {
        return this.selectedDate
      }
    }
  }
}
</script>
